var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mt-4 wrap-detail shadow bg-white rounded",
      class: { toggle: _vm.toggle }
    },
    [
      _c(
        "div",
        {
          staticClass: "toggle-button",
          on: {
            click: function($event) {
              return _vm.toggleView()
            }
          }
        },
        [
          !_vm.toggle
            ? _c("font-awesome-icon", {
                staticClass: "toggle-icon",
                attrs: { icon: "chevron-circle-up" }
              })
            : _vm._e(),
          _vm.toggle
            ? _c("font-awesome-icon", {
                staticClass: "toggle-icon",
                attrs: { icon: "chevron-circle-down" }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-tabs",
        {
          attrs: { align: "center", "nav-wrapper-class": "animated fadeInDown" }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Información" } },
            [_c("PropertiesView", { staticClass: "animated fadeIn" })],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Permisos" } },
            [_c("PermissionsView", { staticClass: "animated fadeIn" })],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Suscripciones" } },
            [_c("SubscriptionsView", { staticClass: "animated fadeIn" })],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Comentarios" } },
            [_c("CommentsView", { staticClass: "animated fadeIn" })],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Bitácora" } },
            [_c("BinnacleView", { staticClass: "animated fadeIn" })],
            1
          ),
          _vm.showApprovalExpedientView
            ? _c(
                "b-tab",
                { attrs: { title: "Aprobaciones" } },
                [
                  _c("ApprovalExpedientView", {
                    staticClass: "animated fadeIn"
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.haveFileCreated
            ? _c(
                "b-tab",
                { attrs: { title: "Expedientes" } },
                [
                  _c("FileExpedientView", {
                    staticClass: "animated fadeIn",
                    attrs: { file: _vm.fileCreated }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }